// extracted by mini-css-extract-plugin
export default {"error-header":"useDocumentSign_error-header__N21DN"};